import React from 'react';
import PropTypes from 'prop-types';
import { get, flatten, map } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, getVideoThumbnail, Image } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css `
.call-out-box {
  background-color: ${colors.whiteDarker};
  padding: 90px 60px;
  font-size: 24px;

  li,
  p {
    font-size: 24px;
  }
}

.gallery {
  padding: 0 0 90px;
  text-align: center;

  h3 {
    font-family: ${typography.Serif};
    color: ${colors.black};
    font-size: 45px;
    line-height: 1.3;
    text-align: center;
    @media (max-width: 767px) {
      font-size: 29px;
      margin: 0 0 30px;
    }
  }


  .gallery-tabs {
    .gallery-tab {
      padding: 15px 60px;
      background-color: ${colors.whiteDark};
      border: 0;
      margin: 0 1px;
      text-transform: uppercase;
      font-family: $font-family-condensed;
      font-weight: 700;
      opacity: 0.5;
    }

    .gallery-tab .active {}
  }

  .gallery-content {
    padding: 90px 0;
    background-color: ${colors.whiteDark};

    ul {
      padding: 0;
      list-style: none;
      margin: 0 -15px;
      display: flex;
      flex-wrap: wrap;

      li {
        width: 100%;
        padding: 15px;
        @media(min-width: 768px) {
          width: 33%;
        }

        img {
          cursor: pointer;
          width: 100%;
          height: auto;
        }
      }
    }
  }

  .main-gallery-link-dropdown {
    background-color: ${colors.color2};
    width: 400px;
    max-width: 94%;
    left: 50%;
    margin-left: -200px;
    position: absolute;
    z-index: 101;
    max-height: 615px;
    overflow: scroll;
    @media (max-width: 767px) {
      margin: 0;
      left: 3%;
    }

    span {
      list-style: none;
      margin: 0;
      text-align: left;
      border-bottom: 1px solid #59758B;
      color: ${colors.white};
      font-weight: 800px;
      font-size: 16px;
      letter-spacing: 2px;
      line-height: 40px;
      text-transform: uppercase;
      padding: 0;
      display: block;
      cursor: pointer;

      &:last-child a {
        background-color: ${colors.color1};
        border-bottom: 0;
        background-image: url("/images/icon-filter.svg");
        background-position: 95% 8px;
        background-size: 22px 22px;
        background-repeat: no-repeat;

        &:hover {
          background-color: ${colors.color1Lighter};
          color: ${colors.white};
        }
      }


    }
  }
}

.ButtonGallery {
  padding: 0 20px !important;

  &:hover {
    background-color: ${colors.color1};
    font-weight: 700;
  }
}

.ButtonGalleryItem {
  padding: 0 20px 0 30px !important;
  position: relative;

  &::before {
    content: "- ";
  }

  &:hover {
    background-color: ${colors.color1};
    font-weight: 700;
  }
}
`;

class Gallery extends React.Component {
  constructor(props) {
    super(props);

    const increment = 3;

    this.state = {
      increment,
      limit: increment,
      section: 'photo',
      mainDropdown: false,
      collection: null,
      galleryName: null,
    };

    this.showMore = this.showMore.bind(this);
  }

  handleTabClick = event => {
    event.preventDefault();

    const section = get(event, 'target.dataset.section');

    this.setState({
      section,
    });
  }

  changePhotoCategory = (collection, galleryName) => {
    this.setState({
      collection,
      galleryName,
    });
  }

  clickedAllImages() {
    this.setState({
      mainDropdown: !this.state.mainDropdown,
      collection: null,
      galleryName: null,
    });
  }

  closeDropdownMenuItems(collection, gallery) {
    this.changePhotoCategory(collection, gallery);
    this.setState({
      mainDropdown: !this.state.mainDropdown,
    });
  }

  toggleDropdown = e => {
    e.preventDefault();

    this.setState({
      mainDropdown: !this.state.mainDropdown,
    });
  }

  closeDropdown = () => {
    this.setState({
      mainDropdown: false,
    });
  }

  showMore() {
    this.setState({
      limit: this.state.limit + this.state.increment,
    });
  }

  render() {
    const { videos, categories, photos } = this.props;
    const { collection, galleryName, section, mainDropdown, limit } = this.state;

    let categoryPhotos = flatten(map(flatten(map(categories, 'gallery')), 'images'));
    if (collection && galleryName) {
      const coll = categories.find(c => c.collection_name === collection);
      const gal = coll.gallery.find(g => g.name === galleryName);
      categoryPhotos = get(gal, 'images', []);
    } else if (collection) {
      const coll = categories.find(c => c.collection_name === collection);
      categoryPhotos = flatten(map(coll.gallery, 'images', []));
    }

    return (
      <div className={styles}>
        <div className="gallery" id="gallery">
          <div className="gallery-tabs" >
            <button
              className="gallery-tab"
              data-section="photo"
              onClick={this.handleTabClick}
            >
              Photo Gallery
            </button>
            {
              videos.length > 0 &&
              <button
                className="gallery-tab"
                data-section="video"
                onClick={this.handleTabClick}
              >
                Video Gallery
              </button>
            }
          </div>
          <div className="gallery-content">
            <div className="container">

              {
                section === 'photo' &&
                <div>
                  {galleryName &&
                    <h3 className="underdog">{collection ? `${collection}${galleryName ? ` - ${galleryName}` : ''}` : 'All Photos'}</h3>
                  }
                  {
                    mainDropdown &&
                    <div className="main-gallery-link-dropdown">
                      { collection &&
                        <span
                          className="ButtonGallery"
                          role="button"
                          tabIndex={0}
                          onClick={() => this.clickedAllImages()}
                        >
                          All Images
                        </span>
                      }
                      {categories &&
                        categories.map(item => (
                          <span
                            key={item.collection_name}
                          >
                            <span
                              className="ButtonGallery"
                              role="button"
                              tabIndex={0}
                              onClick={() =>
                                this.closeDropdownMenuItems(item.collection_name, null)
                              }
                            >
                              {item.collection_name}
                            </span>
                            <div>
                              {(item.gallery || []).map(gallery => (
                                <span
                                  className="ButtonGalleryItem"
                                  key={gallery.name}
                                  role="button"
                                  tabIndex={0}
                                  onClick={() =>
                                    this.closeDropdownMenuItems(item.collection_name, gallery.name)
                                  }
                                >
                                  {gallery.name}
                                </span>
                              ))}
                            </div>
                          </span>
                      ))}
                    </div>
                  }
                </div>
              }

              {
                section === 'photo' &&
                <LightBox
                  items={categoryPhotos.length > 0 ? categoryPhotos : photos}
                >
                  <ul>
                    {!categoryPhotos.length > 0 && photos.length > 0 &&
                      photos.slice(0, limit).map((photo, index) => (
                        <li key={photo.contentUrl}>
                          <Image
                            src={photo.contentUrl}
                            alt=""
                            data-index={index}
                            width={500}
                            height={333}
                            exact
                          />
                        </li>
                      ))
                    }
                    {
                      categoryPhotos.length > 0 &&
                      categoryPhotos.slice(0, limit).map((photo, index) => (
                        <li key={photo.contentUrl}>
                          <Image
                            src={photo.contentUrl}
                            alt=""
                            data-index={index}
                            width={500}
                            height={333}
                            exact
                          />
                        </li>
                      ))
                    }
                  </ul>
                </LightBox>
              }

              {
                limit < categoryPhotos.length && section === 'photo' &&
                <div style={{ textAlign: 'center' }}>
                  <button className="load-more-btn" onClick={this.showMore}>Load More</button>
                </div>
              }

              {
                section === 'video' &&
                <LightBox
                  items={videos.map(video => ({
                    element: (
                      <div
                        style={{
                          width: '800px',
                          maxWidth: '80%',
                          margin: '-225px auto 0 auto',
                          top: '50%',
                        }}
                        className="embed-responsive embed-responsive-16by9"
                        dangerouslySetInnerHTML={SanitizeHtml(video)}
                      />
                    ),
                  }))}
                >
                  <ul>
                    {
                      videos.map((video, index) => (
                        <li key={video}>
                          <Image
                            src={getVideoThumbnail(video)}
                            alt=""
                            data-index={index}
                            width={500}
                            height={333}
                            exact
                          />
                        </li>
                      ))
                    }
                  </ul>
                </LightBox>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Gallery.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.string),
  photos: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.object),
};
Gallery.defaultProps = {
  videos: [],
  photos: [],
  categories: [],
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/pages/Additions/Gallery.js